import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import MeasuringDeviceTable from 'components/tables/data/measuring-device/MeasuringDeviceTable';
/**
 * Page used to display measuring devices.
 *
 */
export default function MeasuringDevicesPage() {
  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Nastavenia' }, { title: 'Meracie prístroje' }]}>
      <MeasuringDeviceTable />
    </DashboardLayout>
  );
}
